import createAction from "redux-actions/es/createAction";
import { getProject as getApi } from "../api/index";
import { getSuitType as getSuitApi } from "../api/index";
import { getDate as getDateApi } from "../api/index";
import { getReport as getReportApi } from "../api/index";
import { getProjectCollections as getProjectCollectionsApi } from "../api/index";
import { fetchQt } from '../../quintessential/actions/index';
import {toastr } from 'react-redux-toastr';


export const projectStart = createAction("DEFAULT_PROJECT_START");
export const projectFail = createAction("DEFAULT_PROJECT_FAIL");
export const projectSuccess = createAction("DEFAULT_PROJECT_SUCCESS");

export const defaultPieChart = createAction("DEFAULT_PIE_CHART_START");
export const defaultPieChartSuccess = createAction("DEFAULT_PIE_CHART_SUCCESS");
export const defaultPieChartFail = createAction("DEFAULT_PIE_CHART_FAIL");



export const suitTypeStart = createAction("SUIT_TYPE_START");
export const suitTypeFail = createAction("SUIT_TYPE_FAIL");
export const suitTypeSuccess = createAction("SUIT_TYPE_SUCCESS");

export const dateStart = createAction("DATE_START");
export const dateFail = createAction("DATE_FAIL");
export const dateSuccess = createAction("DATE_SUCCESS");


export const reportPieChartStart = createAction("REPORT_PIE_START");
export const reportPieCharFail = createAction("REPORT_PIE_FAIL");
export const reportClearData = createAction("REPORT_CLEAR_DATA");
export const reportPieCharSuccess = createAction("REPORT_PIE_SUCCESS");

export const reportTrendChartStart = createAction("REPORT_TREND_START");
export const reportTrendCharFail = createAction("REPORT_TREND_FAIL");
export const reportTrendCharSuccess = createAction("REPORT_TREND_SUCCESS");

export const reportTableStart = createAction("REPORT_TABLE_START");
export const reportTableCharFail = createAction("REPORT_TABLE_FAIL");
export const reportTableCharSuccess = createAction("REPORT_TABLE_SUCCESS");

export const getSuitTypes = (value) => {
  return (dispatch) => {
    getSuitApi(value)
      .then((res) => {
        dispatch(suitTypeSuccess(res.data));
      })
      .catch((err) => {
        dispatch(suitTypeFail(err));
      });
  };
};
export const setDefaultPieChart = (value) => {
  return (dispatch) => {
        dispatch(defaultPieChartSuccess(value));
  
  };
};


export const getProjects = (data) => {
  return (dispatch) => {
    getApi(data)
      .then((res) => {
        dispatch(projectSuccess(res.data));
      })
      .catch((err) => {
        let errorMessage="No valid project selections for this project and suite type";
        let httpError= err.message;
        if(httpError.includes('status code 403')){
          dispatch(dateSuccess(''));
          toastr.error('Error', errorMessage);
        }

        dispatch(projectFail(err));
      });
  };
};


export const getSuitType = (value) => {
  return (dispatch) => {
    getApi(value)
      .then((res) => {
        dispatch(projectSuccess(res.data));
      })
      .catch((err) => {
        let errorMessage="No valid project  selections for this project and suite type";
        let httpError= err.message;
        if(httpError.includes('status code 403')){
          dispatch(dateSuccess(''));
          toastr.error('Error', errorMessage);
        }

        dispatch(projectFail(err));
      });
  };
};
export const getProjectCollections =  () => {
  return async (dispatch) => {
    await getProjectCollectionsApi()
      .then((res) => {
        dispatch(projectSuccess(res.data));
      })
      .catch((err) => {
        dispatch(projectFail(err));
      });
  };
};

export const getDates = (value , project) => {
  return (dispatch) => {
    getDateApi(value, project)
      .then((res) => {
        let checkDateValid=res?.data?.dateOfExecutions;
        let dates= (checkDateValid && checkDateValid.length>0 )?checkDateValid:'';
        dispatch(dateSuccess(dates));
      })
      .catch((err) => {
        let errorMessage="No valid date selections for this project and suite type";
        let httpError= err.message;
        if(httpError.includes('status code 412')){
          dispatch(dateSuccess(''));
          toastr.error('Error', errorMessage);
        }

        dispatch(dateFail(err));
      });
  };
};

export const getReport = (value , project, type) => {
  return (dispatch) => {
    getReportApi(value, project, type)
      .then((res) => {
        switch(type){
          case 'piechart':
          dispatch(reportPieCharSuccess(res.data));
          return;
          case 'trendchart':
            dispatch(reportTrendCharSuccess(res.data));
          return;
          case 'table':
            dispatch(reportTableCharSuccess(res.data));
            return;
         
        }
      })
      .catch((err) => {
        switch(type){
          case 'piechart':
          dispatch(reportPieCharFail(err));
          return;
          case 'trendchart':
            dispatch(reportTrendCharFail(err));
          return;
          case 'table':
            dispatch(reportTableCharFail(err));
            return;
        }
      });
  };
};

export const getQtData =  (project, data) => {
  return async (dispatch) => {
    await dispatch(fetchQt(data,project));
  };
};
